import React, { useEffect, useRef, useState } from "react";
import { useAtom } from "jotai";
import moment from 'moment-timezone';
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import anchorme from "anchorme";
import PerfectScrollbar from 'react-perfect-scrollbar';

import "./chatroom.scss";
import "./chatroom-responsive.scss";
import styles from './chatroom.module.scss'
import { IChatroomProps } from "./IChatroomProps";
import { MessagingService } from "../../../api/services/messaging";
import ConfirmModal from "../ConfirmModal";
import ActionsDropdown from "../ActionsDropdown";
import UserComponent from "components/userComponent";
import InfiniteScroll from "react-infinite-scroll-component";
import ScrollSpinner from "components/scrollSpinner";
import Moment from "react-moment";
import ReadMore from "utils/readMore/readMore";
import { ChatMessagesLoader, MobileChatMesLoader } from "components/contentLoaders";
import miscUtils from "utils/miscUtils";

import { ReactComponent as CloseIcon } from "assets/img/close.svg";
import { ReactComponent as AddUserIcon } from "assets/img/add-user.svg";
import { ReactComponent as BackIcon } from "assets/img/arrow-left.svg";
import { ReactComponent as DeletedUserIcon } from "assets/img/deleted-user.svg";

import { chatsAtom, chatsIsUpdatedAtom, showActiveCHatAtom, showNewDirectMessageMenuAtom, showNewGroupMessageMenuAtom, showNewMessageStartupAtom } from "showMessageMenuAtom";
import { DirectChatsContext } from "containers/main/MainComponent";
import HeaderMemberDetails from "containers/AdminMemberDetails/HeaderMemberDetails/HeaderMemberDetails";
import SubscriptionMemberDetails from "containers/AdminMemberDetails/SubscriptionMemberDetails/SubscriptionMemberDetails";
import BioMemberDetails from "containers/AdminMemberDetails/BioMemberDetails/BioMemberDetails";
import CustomFieldsMemberDetails from "containers/AdminMemberDetails/CustomFieldsMemberDetails/CustomFieldsMemberDetails";
import ReactHtmlParser from "react-html-parser"
import { SearchIcon } from "constants/icons";
import CustomUserComponent from "components/CustomUserComponent/CustomUserComponent";
import PaginationDropdown from "components/paginationDropdown";
import AddUsersToContentPopUp from "containers/AddUsersToContentPopUp/AddUsersToContentPopUp";
import { AddUsersToContentPopUpLoader } from "containers/CoursesContainer/Drip/SectionDripSettings/AccessTablePopup/AccessTablePopup";

const Chatroom: React.FC<IChatroomProps> = props => {
  const {
    group,
    toggleProfilesView, isShowProfiles,
    isGroupChat, setIsGroupChat, isChatAdmin,
    chatroom, setChatroom, isViewProfile, setIsViewProfile, isLoadingMessages,
    setIsLoadingMessages, userTimezone,
    theme, setIsCreateDirectchat,
    isCreateDirectchat, setIsUnauthorizedChatroom, isUnauthorizedChatroom, echo,
    setActiveChatroom,
  } = props;

  const [member, setMember] = useState<any>(null);
  const [messages, setMessages] = useState<any>({});
  const [formData, setFormData] = useState<any>({ message: "" });
  const [message, setMessage] = useState<any>({});
  const [messageKey, setMessageKey] = useState<string>("");
  const [isDeleteMessageModalOpen, setToggleDeletMessageModal] = useState<boolean>();
  const [isModalOpen, setToggleModal] = useState<boolean>();
  const [members, setMembers] = useState<any>([]);
  const [isAddMemberModalOpen, setToggleAddMemberModal] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [nonGroupMembers, setNonGroupMembers] = useState<any>({
    data: [],
  });
  const [selectedMembers, setSelectedMembers] = useState<any>([]);
  const [isLeaveGroupchatModalOpen, setToggleLeaveGroupchatModal] = useState<boolean>();
  const [isChatroomFetched, setIsChatroomFetched] = useState<boolean>();
  const [isMessagesFetched, setIsMessagesFetched] = useState<boolean>();
  const [isLeavingGroupChat, setIsLeavingGroupChat] = useState<boolean>(false)
  // const [addMemberModalKey, setAddMemberModalKey] = useState<any>("");
  const [isSending, setIsSending] = useState<boolean>(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const { getCommunityUnread, membersRef, getDirectChats } = React.useContext(DirectChatsContext)

  const [activeChatroomMessage, setActiveChatroomMessage] = useAtom(showActiveCHatAtom);
  const [, setChatIdUpdated] = useAtom(chatsIsUpdatedAtom);
  const [directChats, setDirectChats] = useAtom(chatsAtom) as any;
  const [showNewMessageStartUpText, setNewMessageStartUp] = useAtom(showNewMessageStartupAtom);

  let chatId: any = activeChatroomMessage;
  const messagesRef = useRef({
    per_page: 15,
    current_page: 1,
    next_page_url: "",
    data: [],
    total: 0
  });
  const [totalMessages, setTotalMessages] = useState<any>(0);

  const chatLimitRef = useRef(null);
  const selectionRef = useRef<any>([]);

  useEffect(() => {
    const focusOutCallback = () => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
    }

    const sendMessageInput: HTMLElement = document.getElementById("send-message-textarea") as HTMLElement;
    sendMessageInput.addEventListener("focusout", focusOutCallback);
    return (() => sendMessageInput.removeEventListener("focusout", focusOutCallback));
  }, [])

  const getMemberCanCHat = () => {
    const groupMembership = group && group.user_membership && group.user_membership.id

    return chatroom && Object.keys(chatroom).length > 0 && chatroom.members.find((chatMember: any) => {
      if (
        chatMember.community_member &&
        (chatMember.community_member.user !== null && chatMember.community_member.user !== undefined) &&
        (chatMember.community_member && chatMember.community_member.id !== groupMembership) &&
        chatMember.community_member.can_chat
      ) {
        return true;
      }
    });
  }

  useEffect(() => {
    if (Object.keys(chatroom).length > 0) {
      setIsGroupChat(true);

      setIsChatroomFetched(true);
      setChatroomMembers(chatroom);

      if (!isMessagesFetched && !isCreateDirectchat) {
        fetchMessages(chatroom);
        setIsLoadingMessages(true);
      }

      if (isGroupChat) {
        setIsViewProfile(false);
      }
    }
    if (chatroom.id) {
      if (chatId !== "temp" && !isUnauthorizedChatroom) {
        setActiveChatroom(chatroom.id);
        localStorage.setItem("isShowChatroom", "yes")
        localStorage.setItem("activeChatroomId", chatroom.id);
      }

      const event = '.chatMessage_' + chatroom.id;
      if (echo) {
        echo.channel('chat-room')
          .listen(event, (message: any) => {
            message = message.message;

            let aciveChatId = localStorage.getItem("activeChatroomId");

            if (group.user_membership.user.id !== message.author.id && aciveChatId == message.chat_room_id) {
              fetchMessages();
            }
          })
          .listen(".messageReaction_" + chatroom.id, (message: any) => {
            updateLikeCount(messagesRef.current, message);
          })
          .listen(".messageDeleted_" + chatroom.id, (response: any) => {
            removeDeletedMessage(messagesRef.current, response.messageId)
          });
      }

      updateUnreadMessagesCount();

      getMemberCanCHat()
    }
  }, [chatroom && chatroom.id])


  function updateUnreadMessagesCount() {
    let _chats: any = directChats && directChats.data
    const { chatrooms } = directChats

    _chats && _chats.forEach((chat: any, index: any) => {
      if (chat.id === chatroom.id) {
        chat.unread_messages_count = 0;
        setDirectChats({
          data: _chats,
          chatrooms
        })
        getCommunityUnread();
      }
    })
  }

  useEffect(() => {
    messagesRef.current = {
      per_page: 15,
      current_page: 1,
      next_page_url: "",
      data: [],
      total: 0
    };
    if (chatId !== "temp") {
      if (group && Object.keys(chatroom).length > 0 && !isUnauthorizedChatroom) {
        fetchMessages(chatroom);
        setIsLoadingMessages(true);
      }
    } else if (chatId === "temp" && isCreateDirectchat) {
      setIsLoadingMessages(false);
      setIsGroupChat(false);
      setIsUnauthorizedChatroom(false);
    } else {
      setIsUnauthorizedChatroom(true);
    }
  }, [chatId])

  useEffect(() => {
    if (group && !isChatroomFetched && !isCreateDirectchat && chatId && chatId !== "temp") {
      chatLimitRef.current = group.active_subscription.plan.max_group_chat_size;

      setIsChatroomFetched(true);
      fetchChatroom(chatId);
    }
  }, [group && group.id])
  const [loadingCommunityMembers, setLoadingCommunityMembers] = useState<boolean>(true);

  useEffect(() => {
    if ((chatroom && chatroom.type === 'group')) {
      fetchNonGroupMembers();
    }
  }, [searchQuery.length, chatroom]);

  useEffect(() => {
    if (isModalOpen) {
      lockBackground();
    }
  }, [isModalOpen]);

  function updateLikeCount(_messages: any, _message: any) {
    setMessages({
      data: _messages.data,
      total: _messages.total,
      next_page_url: "",
      current_page: 1,
      per_page: 1
    });
    Object.keys(_messages.data).forEach((key: any) => {
      _messages.data[key].forEach((keyMessage: any, index: any) => {
        if (keyMessage.id === _message.message.id) {
          _messages.data[key][index].reaction_like_count = _message.reactionCount;
        }
      })
    })
    messagesRef.current.total = _messages.total;
    messagesRef.current.data = _messages.data;
    setMessages(messagesRef.current);
  }

  function removeDeletedMessage(_messages: any, messageId: any) {
    setMessages({
      data: _messages.data,
      total: _messages.total,
      next_page_url: "",
      current_page: 1,
      per_page: 1
    });
    Object.keys(_messages.data).forEach((key: any) => {
      _messages.data[key].forEach((keyMessage: any, index: any) => {
        if (keyMessage.id === messageId) {
          _messages.data[key].splice(index, 1);
        }
      })
    })
    messagesRef.current.total = _messages.total - 1;
    messagesRef.current.data = _messages.data;
    setMessages(messagesRef.current);
  }

  function fetchChatroom(chatId: any) {
    if (group) {
      MessagingService.getInstance()
        .getChatroom(group.id, chatId)
        .then((_chatroom: any) => {
          setChatroom(_chatroom);
          setChatroomMembers(_chatroom);
          if (_chatroom.type === 'group') {
            membersRef.current = {
              'chatroomID': _chatroom.id,
              'members_count': _chatroom.members_count
            };
          }

        }).catch((error: any) => {
          setIsUnauthorizedChatroom(true);
        }).finally(() => {
          setIsChatroomFetched(false)
        })
    }
  }

  function setChatroomMembers(_chatroom: any) {
    if (!isUnauthorizedChatroom) {
      const newId = _chatroom ? _chatroom.id : chatId
      if (_chatroom.type === "group") {
        MessagingService.getInstance()
          .getChatroomMembers(group.id, newId)
          .then((_members: any) => {
            setMembers(_members.data);
            if (_chatroom.type === 'group') {
              membersRef.current = {
                'chatroomID': newId,
                'members_count': _members.data.length
              };
            }
          }).catch((error: any) => {
            setIsUnauthorizedChatroom(true);
          })
      } else {
        setIsGroupChat(false);
        getChattingWithMember(_chatroom.members);
      }
    } else if (isUnauthorizedChatroom && isCreateDirectchat) {
      setIsGroupChat(false);
      getChattingWithMember(_chatroom.members);
    }
  }

  function getChattingWithMember(members: any) {
    const _member = members.filter((member: any) => {
      return ((member.community_member && member.community_member.id) !== (group && group.user_membership && group.user_membership.id));
    });
    setMember(_member[0]);
  }

  function sendMessage() {
    if (group && group.messaging_allowed && group.user_membership && group.user_membership.can_chat) {
      if (isCreateDirectchat) {
        setIsSending(true)
        MessagingService.getInstance()
          .createChat(
            group.id,
            "individual",
            "",
            "",
            [chatroom.member_id]
          )
          .then((response: any) => {
            chatId = response.data.id;
            setChatroom(response.data);
            addToDirectChats(response.data);
            submitMessage();
            setActiveChatroom(chatId);
            localStorage.setItem("isShowChatroom", "yes")
            setNewMessageStartUp(false)
            // setChatIdUpdated(true)
          })
          .catch((error: any) => console.error(error))
          .finally(() => {
            // setChatIdUpdated(false)

            setIsSending(false)
          })
      } else {
        submitMessage();
      }
    }
    else {
      toast("Messaging has been disabled.", {
        type: 'error',
        autoClose: 2000,
        position: "top-center",
        hideProgressBar: true,
        theme: "light"
      });
      return;
    }
  }

  function submitMessage() {
    if (formData.message && group) {
      setIsSending(true)
      setChatIdUpdated(true)
      MessagingService.getInstance()
        .sendMessageInChatroom(group.id, chatId, formData.message)
        .then((message: any) => {
          setFormData({ ...formData, message: "" });
          if (isCreateDirectchat) {
            setIsCreateDirectchat(false);
            setActiveChatroomMessage(chatId)
          } else {
            addNewMessage(message.data);
          }
        })
        .catch((error: any) => console.error(error))
        .finally(() => {
          setIsSending(false)
          setChatIdUpdated(false)
        })
    }
  }

  function addToDirectChats(chat: any) {
    const { chatrooms } = directChats
    setDirectChats({
      chatrooms,
      data: [chat, ...directChats.data]
    })
  }

  function addNewMessage(message: any) {
    let _messages = messages;
    if (!messages.data) {
      _messages = messagesRef.current;

      setMessages(_messages);
    } else {
      messagesRef.current = messages;
    }

    const messageDate = message.created_at.split(" ")[0];
    let params: any = {
      isKeyExists: false,
      key: ""
    };
    Object.keys(_messages.data).every(key => {
      if (key === messageDate) {
        params.isKeyExists = true;
        params.key = key;
        return false;
      } else {
        params.isKeyExists = false;
        params.key = key;
        return true;
      }
    });

    addToMessages(params.key, messageDate, message, params.isKeyExists);
    messagesRef.current.total = messagesRef.current.total + 1;
    setMessages(messagesRef.current);
    scrollToView();
  }

  function fetchMessages(_chatroom?: any) {
    if (!isUnauthorizedChatroom) {
      const today = moment.tz(moment(), userTimezone);
      const startDate = today.utc().format("YYYY-MM-DD hh:mm:ss");

      let endDate: any;
      if (!_chatroom && chatroom) {
        endDate = group.created_at;
      } else {
        endDate = chatroom.created_at;
      }

      let per_page: any = 20;
      if (window.screen.height > 1000) {
        per_page = 40;
      }
      if (window.screen.height > 1500) {
        per_page = 60;
      }

      const newId = _chatroom ? _chatroom.id : chatId

      if (group) {
        MessagingService.getInstance()
          .getChatroomMessages(group.id, newId, 1, per_page, startDate.toString(), endDate)
          .then((_messages: any) => {
            setMessages(_messages);
            setIsLoadingMessages(false);
            setIsMessagesFetched(true);
            messagesRef.current = _messages;
            setTotalMessages(_messages.to);
            scrollToView();
          }).catch((error: any) => {
          }).finally(() => setIsMessagesFetched(false))
      }
    }
  }

  function loadMoreMessages() {
    return MessagingService.getInstance()
      .getChatroomMessages(group.id, chatId, messages.current_page + 1, messages.per_page, messages.from_date, messages.end_date)
      .then((_messages: any) => {

        setTotalMessages(_messages.to);
        messagesRef.current = messages;

        Object.keys(_messages.data).forEach(newMessageKey => (
          Object.keys(messages.data).forEach((key: any) => (
            key === newMessageKey ?
              addToMessages(key, newMessageKey, _messages.data[newMessageKey], true)
              :
              addToMessages(key, newMessageKey, _messages.data[newMessageKey], false)
          ))
        ))
        let newMessagesList = messagesRef.current;
        newMessagesList.next_page_url = _messages.next_page_url;
        newMessagesList.per_page = _messages.per_page;
        newMessagesList.current_page = _messages.current_page;
        newMessagesList.total = _messages.total;

        setMessages(newMessagesList);
        messagesRef.current = newMessagesList;
      }).catch((error: any) => console.error(error))
  }

  function scrollToView() {
    const messageElems = document.querySelectorAll(".messages-content-body-messages-single");
    const elemsLength = messageElems.length;

    let lastMessageIndex: any;

    const _messages: any = messagesRef.current.data;
    Object.keys(_messages).forEach((key: any, index: any) => {
      if (index === 0) {
        lastMessageIndex = _messages[key].length - 1;
      }
    })

    const lastMessageElem = elemsLength < 1 ? "" : messageElems[lastMessageIndex];
    if (lastMessageElem) {
      lastMessageElem.scrollIntoView(false);
    }
  }

  function addToMessages(messagesKey: any, newMessageKey: any, fetchedMessages: any, isKeyExists: any) {
    if (isKeyExists) {
      const _messages: any = { ...messagesRef.current };
      if (Array.isArray(fetchedMessages)) {
        _messages.data[messagesKey] = [...fetchedMessages, ...messagesRef.current.data[messagesKey]];
      } else {
        _messages.data[messagesKey] = [...messagesRef.current.data[messagesKey], fetchedMessages];
      }
      messagesRef.current = _messages;
    } else {
      const _messages: any = { ...messagesRef.current };
      if (Array.isArray(fetchedMessages)) {
        _messages.data = { ...messagesRef.current.data, [newMessageKey]: fetchedMessages };
        messagesRef.current = _messages;
      } else {
        _messages.data = { [newMessageKey]: [fetchedMessages], ...messages.data };
        messagesRef.current = _messages;
      }
    }
  }

  function unlockBackground() {
    document.body.classList.remove("stop-scrolling");
  }

  function lockBackground() {
    document.body.classList.add("stop-scrolling");
  }

  function openDeleteMessageModal() {
    setToggleDeletMessageModal(true);
    lockBackground();
  }

  function closeDeleteMessageModal() {
    setToggleDeletMessageModal(false);
    unlockBackground();
  }

  function deleteMessage() {
    MessagingService.getInstance()
      .deleteMessageInChatroom(message.id)
      .then((response: any) => {

        toast("Message deleted successfully.", {
          type: 'success',
          autoClose: 3000
          ,
          position: "top-center",
          hideProgressBar: true,
          theme: "light"
        });

        const refreshedMessages: any = messages.data[messageKey].filter((_message: any) => message.id !== _message.id);
        messages.data[messageKey] = refreshedMessages;

        setMessages(messages);
        closeDeleteMessageModal()
        unlockBackground();
        setChatIdUpdated(true)
      })
      .catch((error: any) => console.error(error))
      .finally(() => {
        setChatIdUpdated(false)
      })
  }

  const [isDeleteModalOpen, setToggleDeleteModal] = useState<boolean>();
  const [isDeletingChat, setIsDeletingChat] = useState<boolean>(false)

  const deleteGroupChatAndMessages = () => {
    if (isDeletingChat) {
      return
    }
    function deleteChat() {
      setIsDeletingChat(true)
      MessagingService.getInstance()
        .deleteChatroom(group.id, chatroom.id)
        .then((response: any) => {
          const refreshedChats = directChats.data.filter((_chatroom: any) => _chatroom.id !== chatroom.id) as any;
          const { chatrooms } = directChats
          setDirectChats({
            chatrooms,
            data: [...refreshedChats]
          })

          toast("Group Message deleted successfully.", {
            type: 'success',
            autoClose: 2000
            ,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
          });

          const firstChatroomId: number = refreshedChats && refreshedChats[0].id
          fetchChatroom(firstChatroomId)
        })
        .catch((error: any) => console.error(error))
        .finally(() => {
          unlockBackground();
          setToggleDeleteModal(false);
          setIsDeletingChat(false)
        })
    }
    deleteChat()
  }

  function openAddMemberModal() {
    lockBackground();
    setToggleAddMemberModal(true);
  }

  function closeAddMemberModal() {
    unlockBackground();
    setToggleAddMemberModal(false);
    setNonGroupMembers({
      data: [],
    });
    setSelectedMembers([]);
    setSearchQuery('');
    setLoadingCommunityMembers(true)
    // setAddMemberModalKey((Math.random() + 1).toString(36).substring(7));
  }

  function openModal(member: any) {
    setMember(member);
    setToggleModal(true);
  }

  function closeModal() {
    setToggleModal(false);
    unlockBackground();
    setToggleDeleteModal(false);
  }
  const [isGroupchatModal, setIsGroupchatModal] = useState<boolean>();

  function openLeaveGroupchatModal() {
    if (isGroupChat) {
      setIsGroupchatModal(true);
      setToggleLeaveGroupchatModal(true);
    }
    else {
      setToggleLeaveGroupchatModal(true);
    }
  }

  function closeLeaveGroupchatModal() {
    setToggleLeaveGroupchatModal(false);
    unlockBackground();
  }

  function addSelectedMembers() {
    // const selectedMembersIds = new Set<number>();

    // const selectedMembersIndexes: any = selectedMembers.map((index: any) => {
    //   return +index;
    // });

    // if (selectedMembersIndexes.length === 0) {
    //   return
    // }

    // nonGroupMembers.data.forEach((member: any, memberIndex: number) => {
    //   if (selectedMembersIndexes.includes(memberIndex)) {
    //     selectedMembersIds.add(+member.id);
    //   }
    // });
    // const groupChatLimit = group.active_subscription.plan.max_group_chat_size;

    // const selectedMembersIdsArray = Array.from(selectedMembersIds); // Convert Set to an array

    const selectedMembersIds = new Set<number>();

    if (selectedMembers.length === 0) return;

    selectedMembers.forEach((member: any) => {
      selectedMembersIds.add(+member.id);
    });

    const groupChatLimit = group.active_subscription.plan.max_group_chat_size;
    const selectedMembersIdsArray = Array.from(selectedMembersIds);

    if ((selectedMembers.length + members.length) > groupChatLimit) {
      toast("Only 10 members are allowed in a group message.", {
        type: 'warning',
        autoClose: 6000
        ,
        position: "top-center",
        hideProgressBar: true,
        theme: "light"
      });
    } else {

      MessagingService.getInstance()
        .addGroupchatMember(group.id, chatId, selectedMembersIdsArray)
        .then((response: any) => {
          toast("Members added successfully.", {
            type: 'success',
            autoClose: 3000
            ,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
          });

          const refreshedMembers: any = [...members, ...response.data];
          setMembers(refreshedMembers);
          membersRef.current = {
            'chatroomID': chatId,
            'members_count': refreshedMembers.length
          };

          closeAddMemberModal()
          setSelectedMembers([]);
          props.setIsMemberAddGroupChat(true)
        })
        .catch((error: any) => console.error(error))
        .finally(() => {
          setIsButtonDisabled(false)
          props.setIsMemberAddGroupChat(false)
        })
    }
  }

  function viewProfile(_member: any) {
    setIsViewProfile(true);
    setMember(_member);
  }


  function isAboveMembersLimit(chatLimit: any, totalSelected: any, totalMembers: any) {
    if ((totalSelected + totalMembers) >= chatLimit) {
      return true;
    } else {
      return false;
    }
  }


  function fetchNonGroupMembers() {
    if (group && chatId !== 'temp') {
      MessagingService.getInstance()
        .getMembersNotInChatroom(group.id, chatId, true, searchQuery)
        .then((members: any) => {
          const _nonGroupMembers = members.data.filter((member: any) => {
            return (member.id !== group.user_membership.id
              && member.active_subscription !== null)
              || (member.role.name !== 'member');
          });

          setNonGroupMembers({
            data: _nonGroupMembers,
            ...members
          });
        }).catch((error: any) => {
          setLoadingCommunityMembers(false);
          console.error(error)
        }).finally(() => {
          setLoadingCommunityMembers(false);
        })
    }
  }

  function loadMoreNonGroupMembers(pageNumber: number) {
    if (group) {
      MessagingService.getInstance()
        .getMembersNotInChatroom(group.id, chatId, true, searchQuery, pageNumber)
        .then((members: any) => {
          const _nonGroupMembers = members.data.filter((member: any) => {
            return (member.id !== group.user_membership.id
              && member.active_subscription !== null)
              || (member.role.name !== 'member');
          });

          setNonGroupMembers({
            data: _nonGroupMembers,
            ...members
          });
        }).catch((error: any) => {
          setLoadingCommunityMembers(false);
          console.error(error)
        }).finally(() => {
          setLoadingCommunityMembers(false);
        })
    }
  }

  const [isRemovingUser, setIsRemovingUser] = useState<boolean>(false)

  const removeMemberFromGroupChat = () => {
    if (isRemovingUser && isModalOpen) {
      return
    }
    else {
      setIsRemovingUser(true)
      MessagingService.getInstance()
        .removeGroupchatMember(group.id, chatId, member.community_member.id)
        .then((removedMember: any) => {

          toast("Member removed successfully.", {
            type: 'success',
            autoClose: 3000
            ,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
          });
          const refreshedMembers = members.filter((_member: any) => _member.id !== member.id);
          setMembers(refreshedMembers);
          membersRef.current = {
            'chatroomID': chatId,
            'members_count': refreshedMembers.length
          };
          closeModal()
          props.setIsMemberAddGroupChat(true)
        })
        .catch((error: any) => console.error(error))
        .finally(() => {
          props.setIsMemberAddGroupChat(false)
          setIsRemovingUser(false)
        })
    }
  }

  const [, setShowNewDirectMessageMenu] = useAtom(showNewDirectMessageMenuAtom);

  const leaveGroupDirectChat = () => {
    if (isLeavingGroupChat) {
      return
    }
    function leaveGroupchat() {
      setIsLeavingGroupChat(true)
      let refreshedDirectChats: any
      MessagingService.getInstance()
        .leaveChatroom(group.id, chatId)
        .then((response: any) => {
          toast(`You have successfully ${isGroupChat ? 'left the group message.' : 'closed this direct message.'}`, {
            type: 'success',
            autoClose: 3000
            ,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
          });

          closeLeaveGroupchatModal();
          refreshedDirectChats = directChats.data.filter((chat: any) => chat.id !== chatroom.id);
          if (refreshedDirectChats.length === 0) {
            setShowNewDirectMessageMenu(true)
            setNewMessageStartUp(true);
            return
          }
          const { chatrooms } = directChats
          setDirectChats({
            chatrooms,
            data: [...refreshedDirectChats]
          })

          chatId = refreshedDirectChats && refreshedDirectChats[0].id
          fetchChatroom(chatId)
          setIsLeavingGroupChat(false)
          if (isGroupChat) {
            switchProfileViews()
            setIsGroupchatModal(false)
          }
          if (isViewProfile) {
            // switchProfileViews()
            setIsViewProfile(false);
          }
        })
        .catch((error: any) => console.error(error))
        .finally(() => {
          getDirectChats()
        })
    }
    leaveGroupchat()
  }


  function getDateDiff(date: any) {
    const today = moment.tz(moment(), userTimezone);
    const messageDate = moment.tz(date.key, userTimezone);

    const days = today.diff(messageDate, "days");
    return days;
  }

  function isMessageAuthor(message: any) {
    if (group.user_membership.user.id === message.author.id) {
      return true;
    } else {
      return false;
    }
  }
// @ts-ignore
  function addToSelection(selection: any) {
    const currentSelectionTotal = selectionRef.current ? selectionRef.current : 0;
    if (currentSelectionTotal < selection.length) {
      if (!isAboveMembersLimit(chatLimitRef.current, selectionRef.current, membersRef.current.members_count)) {
        setSelectedMembers(selection);
        selectionRef.current = selection.length;
      } else {
        selection.pop();
        if (group) {
          toast("Only 10 members are allowed in a group message.", {
            type: 'warning',
            autoClose: 6000
            ,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
          });
          return
        }
      }
    } else {
      setSelectedMembers(selection);
      selectionRef.current = selection.length;
    }
  }

  const toggleUserSelected = (member: any) => {
    const isMemberSelected = selectedMembers.some((selectedMember: any) => selectedMember.user.id === member.user.id);
    let newSelection: any[];

    if (isMemberSelected) {
      // Remove the member from the selection
      newSelection = selectedMembers.filter((selectedMember: any) => selectedMember.user.id !== member.user.id);
    } else {
      // Add the member to the selection
      newSelection = [...selectedMembers, member];
    }

    const currentSelectionTotal: any = selectionRef.current ? selectionRef.current : 0;

    if (currentSelectionTotal < newSelection.length) {
      // Check if we are exceeding the member limit
      if (!isAboveMembersLimit(chatLimitRef.current, selectionRef.current, membersRef.current.members_count)) {
        // Update the selection and selectionRef if the limit isn't exceeded
        setSelectedMembers(newSelection);
        selectionRef.current = newSelection.length;
      } else {
        // If the limit is exceeded, show a warning
        toast("Only 10 members are allowed in a group message.", {
          type: 'warning',
          autoClose: 6000
          ,
          position: "top-center",
          hideProgressBar: true,
          theme: "light"
        });
      }
    } else {
      // If the total selection size is within the limit, update the selection
      setSelectedMembers(newSelection);
      selectionRef.current = newSelection.length;
    }
  };

  function switchProfileViews() {
    toggleProfilesView();
    setIsViewProfile(false);
  }

  function toggleMessageLike(message: any, key: any, index: any) {
    if (message.liked) {
      unlikeMessage(message, key, index);
    } else {
      likeMessage(message, key, index);
    }
  }

  function likeMessage(message: any, key: any, index: any) {
    const _messages = messages;
    _messages.data[key][index].reaction_like_count ? _messages.data[key][index].reaction_like_count++ : _messages.data[key][index].reaction_like_count = 1;
    _messages.data[key][index].liked = true;

    setMessages(_messages);

    MessagingService.getInstance()
      .likeChatroomMessage(group.id, chatId, message.id, "like")
      .then((response: any) => {
        _messages.data[key][index].liked = true;
        setMessages(_messages);
      }).catch((error: any) => console.error(error))
  }

  function unlikeMessage(message: any, key: any, index: any) {
    const _messages = messages;
    _messages.data[key][index].reaction_like_count ? _messages.data[key][index].reaction_like_count-- : _messages.data[key][index].reaction_like_count = 0;
    _messages.data[key][index].liked = false;

    setMessages(_messages);

    MessagingService.getInstance()
      .unlikeChatroomMessage(group.id, chatId, message.id, "like")
      .then((response: any) => {
        _messages.data[key][index].liked = false;
        setMessages(_messages);
      }).catch((error: any) => console.error(error))
  }

  function scrollbarVisible(elementId: any) {
    const element = document.getElementById(elementId);

    if (element) {
      // @ts-ignore
      return element.scrollHeight > element.clientHeight;
    }
    return false;
  }

  const chatDisabled = group && group.messaging_allowed && group.user_membership && group.user_membership.can_chat
  const [, setShowNewGroupMessageMenu] = useAtom(showNewGroupMessageMenuAtom);

  function editGroupchat() {
    props.setIsEditGroupchat(true);
    props.setChat(chatroom);
    setActiveChatroomMessage(chatroom.id)
    setShowNewGroupMessageMenu(true)
  }

  function openDeleteModal() {
    setToggleDeleteModal(true);
    lockBackground();
  }

  const getChatStatus = () => {
    if (!isGroupChat && member &&
      (member.community_member.active_subscription === null && !miscUtils.isTeamMember(member.community_member))
    ) {
      return true
    }
    else {
      return false
    }
  }

  const chatroomPlaceholder = (chatDisabled === false) || !getMemberCanCHat() ? 'Messaging is disabled.' : !isGroupChat && member && ((member.community_member.active_subscription === null && !miscUtils.isTeamMember(member.community_member)) ? `${member.community_member.user && (member.community_member.user.full_name ? member.community_member.user.full_name : `No Name`)} is inactive.` : 'Write message')
  return (
    <div className="messages-grouped flex">
      <div className="messages-content">
        {
          !isLoadingMessages &&
          <>
            {
              member &&
              member.community_member &&
              member.community_member.user &&
              !isGroupChat &&
              (
                <div className="messages-content-header messages-content-header-message">
                  <span
                    className="arrow-previous"
                    style={miscUtils.customThemeSet(props.theme) ? { color: props.theme.custom.primaryColor } : {}}
                    onClick={() => {
                      // removeCookieValue("isShowChatroom");
                      props.setIsShowChatroom(false);
                    }}
                  >
                    <BackIcon />
                  </span>
                  <UserComponent
                    hideAdmin={true}
                    user={member.community_member.user}
                    hideName={true}
                    profilePicture={member.community_member.user.profile_image}
                    showProfileSlider={false}
                    userMembership={member.community_member}
                  />

                  <div className="ind-action-separator">
                    <div className="messages-content-header-wrap">
                      {
                        member.community_member.user.full_name !== null ?
                          <b>{member.community_member.user.full_name}</b>
                          :
                          <b>No name</b>
                      }
                      <span
                        className="view-profile"
                        onClick={() => toggleProfilesView()}
                        style={miscUtils.customThemeSet(theme) ? { color: theme.custom.primaryColor } : {}}
                      >
                        View profile
                      </span>
                    </div>
                    <div className="chatroom-actions-dropdown">
                      {isChatAdmin(chatroom, group.user_membership.id) ?
                        <ActionsDropdown
                          objectId={chatroom}
                          actions={
                            [
                              {
                                "name": "Close",
                                "callback": openLeaveGroupchatModal
                              }
                            ]
                          }
                        /> :
                        <ActionsDropdown
                          objectId={chatroom}
                          actions={
                            [
                              {
                                "name": "Close",
                                "callback": openLeaveGroupchatModal
                              }
                            ]
                          }
                          isGroupChat={false}
                        />
                      }
                    </div>
                  </div>
                </div>
              )
            }
            {members.length > 0 && isGroupChat && (
              <div className="messages-content-header messages-content-header-message">
                <span
                  className="arrow-previous"
                  style={miscUtils.customThemeSet(props.theme) ? { color: props.theme.custom.primaryColor } : {}}
                  onClick={() => {
                    // removeCookieValue("isShowChatroom");
                    props.setIsShowChatroom(false);
                  }}
                >
                  <BackIcon />
                </span>
                <span
                  className={`messages-content-header-profiles ${isGroupChat ? "groupchat" : ""} ${isShowProfiles ? "active" : ""}`}
                  onClick={() => switchProfileViews()}
                >
                  {
                    chatroom.type === 'group' &&
                    <GroupProfileImages
                      members={members}
                      group={group}
                      chat={chatroom}
                    />
                  }
                </span>
                <div className="ind-action-separator">
                  <div className="messages-content-header-wrap">
                    <b style={{ fontSize: '14px' }}>{chatroom.title}</b>
                    {chatroom.description && (
                      chatroom.description.length > 100 ?
                        <ReadMore
                          text={chatroom.description}
                          numberOfLines={1}
                          lineHeight={1}
                          readMoreCharacterLimit={100}
                          showLessButton={true}
                          onContentChange={() => { }}
                        />
                        :
                        <span onClick={() => switchProfileViews()}>
                          {chatroom.description}
                        </span>
                    )}
                  </div>

                  <div className="chatroom-actions-dropdown">
                    {isChatAdmin(chatroom, group.user_membership.id) ?
                      <ActionsDropdown
                        objectId={chatroom}
                        actions={
                          [
                            {
                              "name": "Edit",
                              "callback": editGroupchat
                            },
                            {
                              "name": "Delete",
                              "callback": openDeleteModal
                            }
                          ]
                        }
                      /> :
                      <ActionsDropdown
                        objectId={chatroom}
                        actions={
                          [
                            {
                              "name": "Leave group",
                              "callback": openLeaveGroupchatModal
                            }
                          ]
                        }
                        isGroupChat={true}
                      />
                    }
                  </div>
                </div>
              </div>
            )}
          </>
        }
        <div
          className={`messages-content-body ${isGroupChat ? 'messages-content-body--group' : 'messages-content-body--direct'}`}
        >
          <div id="chatMessages"
            className={`messages-content-body-messages ${scrollbarVisible("chatMessages") ? "scrollbar-visible" : ""}`}
            style={{
              display: 'flex',
              flexDirection: 'column-reverse',
            }}
          >

            {isLoadingMessages || (directChats.length === 0) ?
              <>
                <div className="big-loading">
                  <ChatMessagesLoader />
                </div>
                <div className="loading">
                  <MobileChatMesLoader />
                </div>
              </>
              :
              directChats.data.length > 0 && messages.data && Object.keys(messages.data).length > 0 ?
                <InfiniteScroll
                  scrollableTarget={"chatMessages"}
                  style={{ display: 'flex', flexDirection: 'column-reverse' }}
                  dataLength={totalMessages}
                  next={() => loadMoreMessages()}
                  hasMore={messages.next_page_url ? true : false}
                  inverse={true}
                  initialScrollY={10}
                  scrollThreshold={0.5}
                  // endMessage = {"No more messages"}
                  loader={<span><ScrollSpinner label={"Loading..."} /></span>}
                >
                  {Object.keys(messages.data).map((key: any, index: any) => (
                    <div key={index}>
                      {messages.data[key].length > 0 && (
                        <div className="messages-content-body-messages-header">
                          {getDateDiff({ key }) < 1 && (
                            <span>Today</span>
                          )}
                          {getDateDiff({ key }) === 1 && (
                            <span>Yesterday</span>
                          )}
                          {getDateDiff({ key }) > 1 && (
                            <span><Moment format="dddd, MMM DD" tz={userTimezone}>{key}</Moment></span>
                          )}
                        </div>
                      )}
                      {messages.data[key].map((message: any, index: any) => (
                        <div className="messages-content-body-messages-single" key={index}>
                          {message.author && (
                            <UserComponent
                              hideAdmin={true}
                              user={message.author}
                              hideName={true}
                              profilePicture={message.author.profile_image}
                            />
                          )}
                          <div className="messages-content-body-messages-single-wrap">
                            <div className="hover-buttons">
                              <img className="dots" src={require("../images/heart-2.svg")} alt="..." onClick={() => {
                                toggleMessageLike(message, key, index);
                              }} />
                              {isGroupChat ?
                                (isChatAdmin(chatroom, group.user_membership.id) || isMessageAuthor(message)) && (
                                  <img className="trash" src={require("../images/trash.svg")} alt="..."
                                    onClick={() => {
                                      setMessage(message);
                                      setMessageKey(key)
                                      openDeleteMessageModal()
                                    }}
                                  />
                                ) :
                                isMessageAuthor(message) && (
                                  <img className="trash" src={require("../images/trash.svg")} alt="..."
                                    onClick={() => {
                                      setMessage(message);
                                      setMessageKey(key)
                                      openDeleteMessageModal()
                                    }}
                                  />
                                )
                              }
                            </div>
                            {
                              message.author.full_name !== null ?
                              <div className={styles.messageAuthor}>
                                <h1 className={styles.messageAuthor__name}>{message.author.full_name}</h1>
                                  {(message.author && message.author.has_left_chatroom && isGroupChat) ? <div className={styles.messageAuthor__span}> Removed User</div> : <></>}
                                  <p className={styles.messageAuthor__time}><Moment utc={true} format="hh:mm A" tz={userTimezone}>{message.created_at}</Moment></p>
                              </div>
                                :
                                 <div className={styles.messageAuthor}>
                                  <h1 className={styles.messageAuthor__name}>No name</h1>
                                  <p><Moment utc={true} format="hh:mm A" tz={userTimezone}>{message.created_at}</Moment></p>
                                  </div>
                            }
                            <p style={{ fontSize: '14px' }} className="message-message">{ReactHtmlParser(anchorme(message.message))}</p>
                            {message.reaction_like_count > 0 && (
                              <span className="message-likes" onClick={() => {
                                toggleMessageLike(message, key, index);
                              }}><img className="dots" src={require("../images/heart-red.svg")} alt="..." /><span className={`${message.liked ? "message-liked" : ""}`}>{message.reaction_like_count}</span></span>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </InfiniteScroll>
                :
                (showNewMessageStartUpText || directChats.data.length > 0) &&
                <div className="messages-content-body-messages-single no-chat-history">
                  {isGroupChat && (
                    <img className="group-chat" src={require("../images/chat.svg")} />
                  )}
                  {member && !isGroupChat && (
                    <UserComponent
                      hideAdmin={true}
                      user={member.community_member && (member.community_member.user)}
                      hideName={true}
                      profilePicture={member.community_member.user.profile_image}
                    />
                  )}
                  <div className="messages-content-body-messages-single-wrap">
                    <p>
                      {isGroupChat ?
                        <span>This is the beginning of your group message.</span>
                        :
                          <>
                            {
                              member && member.community_member && member.community_member.user && member.community_member.user.full_name !== null ?
                        <span>
                                  This is the beginning of your direct message with <span className="chat-with">@{member && member.community_member && member.community_member.user && member.community_member.user.full_name}</span>.
                        </span>
                                :
                                <span> This is the beginning of your direct message with <span className="chat-with">@No name</span>.</span>
                            }
                          </>
                      }
                    </p>
                  </div>
                </div>
            }
          </div>
        </div>
        <div className="messages-input">
          <textarea
            className={chatroomPlaceholder === 'Write message' ? 'message-textarea' : isGroupChat ? 'message-textarea' : ''}
            onChange={e => {
              e.preventDefault();
              const messageData = e.target.value
              if (messageData.trim() === '') {
                setFormData({ ...formData, message: '' })
              }
              else {
                setFormData({ ...formData, message: messageData })
              }
            }
            }
            value={formData.message}
            id="send-message-textarea"
            disabled={!chatDisabled || getChatStatus() || !getMemberCanCHat()}
            placeholder={!isLoadingMessages ? (chatroomPlaceholder ? chatroomPlaceholder : isGroupChat ? 'Write message' : '') : ''}
          />
          <button
            className={`send-message-btn ${!formData.message ? "disabled" : ""}`}
            onClick={sendMessage}
            style={miscUtils.customThemeSet(theme) ? { backgroundColor: theme.custom.primaryColor } : {}}
            disabled={isSending || !chatDisabled || getChatStatus() || !getMemberCanCHat()}
          >
            {isSending ? 'Sending...' : 'Send'}
          </button>
        </div>
      </div>
      {(member && !isGroupChat) && (
        <SingleChatMemberProfile
          member={member}
          toggleProfilesView={toggleProfilesView}
          setIsViewProfile={setIsViewProfile}
          isGroupChat={isGroupChat}
          theme={theme}
          group={group}
        />
      )}
      {isGroupChat && !isViewProfile && (
        <GroupChatProfilesSidebar
          members={members}
          openAddMemberModal={openAddMemberModal}
          closeAddMemberModal={closeAddMemberModal}
          fetchNonGroupMembers={fetchNonGroupMembers}
          ActionsDropdown={ActionsDropdown}
          openModal={openModal}
          viewProfile={viewProfile}
          toggleProfilesView={toggleProfilesView}
          chatroom={chatroom}
          isChatAdmin={isChatAdmin}
          setSearchQuery={setSearchQuery}
          openLeaveGroupchatModal={openLeaveGroupchatModal}
          leaveGroupchat={leaveGroupDirectChat}
          group={group}
          theme={theme}
        />
      )}
      {isGroupChat && isViewProfile && (
        <SingleChatMemberProfile
          member={member}
          toggleProfilesView={toggleProfilesView}
          setIsViewProfile={setIsViewProfile}
          isGroupChat={isGroupChat}
          theme={theme}
          directChats={directChats && directChats.data}
          group={group}
          setIsCreateDirectchat={setIsCreateDirectchat}
          setChatroom={setChatroom}
        />
      )}
      <ConfirmModal
        isModalOpen={isDeleteMessageModalOpen}
        closeModal={closeDeleteMessageModal}
        actionCallback={deleteMessage}
        modalSubTitle="Are you sure you want to delete this message? This action cannot be undone."
        modalTitle="Delete Message"
        actionBtn="Delete"
      />
      {member && (
        <ConfirmModal
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          actionCallback={removeMemberFromGroupChat}
          modalTitle={`Remove ${member.community_member.user ? member.community_member.user.full_name : ""}`}
          modalSubTitle="Are you sure you want to remove this member? This action cannot be undone."
          actionBtn={`${isRemovingUser ? "Removing..." : 'Remove'}`}
        />
      )}
      <ConfirmModal
        isModalOpen={isDeleteMessageModalOpen}
        closeModal={closeDeleteMessageModal}
        actionCallback={deleteMessage}
        modalSubTitle="Are you sure you want to delete this message? This action cannot be undone."
        modalTitle="Delete Message"
        actionBtn="Delete"
      />

      <ConfirmModal
        isModalOpen={isLeaveGroupchatModalOpen}
        closeModal={closeLeaveGroupchatModal}
        actionCallback={leaveGroupDirectChat}
        modalSubTitle={`Are you sure you want to ${isGroupchatModal ? "leave this group message? This action cannot be undone." : "close this direct message?"} `}
        modalTitle={`${isGroupchatModal ? `Leave group message (${chatroom.title})` : `Close direct message ${member && member.community_member ? `with ${member && member.community_member.user && member.community_member.user.full_name ? member.community_member.user.full_name : "No name"}` : ""}`}`}
        actionBtn={`${isGroupchatModal ? (isLeavingGroupChat ? "Leaving..." : "Leave") : (isLeavingGroupChat ? "Closing..." : "Close")}`}

      />
      <ConfirmModal
        isModalOpen={isDeleteModalOpen}
        closeModal={closeModal}
        actionCallback={deleteGroupChatAndMessages}
        modalTitle={`Delete Group Message`}
        modalSubTitle={`Are you sure you want to delete this group message? This action cannot be undone.`}
        actionBtn={`${isDeletingChat ? "Deleting.." : "Delete"}`}
      />
      <>
        {/* <Modal isOpen={isAddMemberModalOpen} onRequestClose={closeAddMemberModal} size={"539px"}>
          <div className="messages-add-members-modal flex flex-direction-column">
            <div className="messages-add-members-modal-content confirmation-modal-content">
              <div className="messages-add-members-modal-content-header">
                <button
                  className={"modal__close"}
                  onClick={() => {
                    closeAddMemberModal();
                    setNoSearchFound(undefined)
                  }}
                >
                  <span className="close">
                    <CloseIcon />
                  </span>
                </button>
              </div>
              <p className="add-people">Add people</p>

              <div className="modal-form--wrap">
                <div className="form-group flex flex-direction-column">
                  <input
                    onChange={e => {
                      setSearchQuery(e.target.value);
                    }}
                    value={searchQuery ? searchQuery : ""}
                    name="channel_name"
                    type="text"
                    placeholder="Search by name"
                    aria-label="Full Name"
                    className="search-input"
                  />
                  <img src={require("../images/search.svg")} className="search-icon" />
                </div>

                <div className="form-group flex flex-direction-column">
                  <div
                    id={"scroll"}
                    className="members__scrollarea"
                  >
                    {
                      nonGroupMembers.data.length > 0 ?
                        <GTable
                          key={addMemberModalKey}
                          selectionChanged={(selection: any) => {
                            addToSelection(selection);
                          }}
                          classes={["modal-member"]}
                          columns={columns}
                          section={"invite_members"}
                          data={nonGroupMembers.data}
                          total={nonGroupMembers.total}
                          hideActions={true}
                          membersCounter={selectedMembers.length}
                          customCounter={`${selectedMembers.length + members.length} / ${group ? group.active_subscription.plan.max_group_chat_size : 0}`}
                          group={group}
                        />
                        :
                        <>
                          {
                            notSearchFound ?
                              <span className="loading-results">{notSearchFound}</span>
                              :
                              <span className="loading-mes">Loading community members...</span>
                          }
                        </>
                    }
                  </div>
                </div>

                <div className="form-group__action">
                  <div className="flex flex-justify-center" style={members.next_page_url ? { display: "flex" } : { display: "none" }}>
                    <span className="load-more">Load More...</span>
                  </div>

                  <div className={`flex flex-justify-center ${members.next_page_url ? "" : "adjust"}`}>
                    <button
                      onClick={(e: any) => {
                        e.preventDefault();
                        addSelectedMembers();
                        if (selectedMembers.length > 0) {
                          setIsButtonDisabled(true);
                        }
                      }}
                      disabled={isButtonDisabled}
                      className="btn btn-primary btn-xl-size"
                      style={miscUtils.customThemeSet(theme) ? { color: theme.custom.fontColor, backgroundColor: theme.custom.primaryColor, borderColor: theme.custom.primaryColor } : {}}
                    >
                      {
                        isButtonDisabled ? 'Adding members...' : 'Add member(s)'
                      }

                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal> */}

        <AddUsersToContentPopUp
          isOpen={isAddMemberModalOpen}
          closePopUp={() => {
            closeAddMemberModal();
          }}
          contentTitle={`Add members to group message`}
          addMembersPopUpID={"add-members-to-group-dm"}
          SearchComp={
            <>
              <input
                placeholder="Search for community members"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    fetchNonGroupMembers();
                  }
                }}
              />
              <span onClick={() => fetchNonGroupMembers()}>
                <SearchIcon />
              </span>
            </>
          }
          AddActionfnComp={
            <button
              disabled={loadingCommunityMembers || selectedMembers.length === 0}
              onClick={() => {
                addSelectedMembers();
                if (selectedMembers.length > 0) {
                  setIsButtonDisabled(true);
                }
              }}
            >
              {isButtonDisabled ? 'Adding...' : 'Add'}
            </button>
          }
          MemberSelection={
            <>
              {nonGroupMembers.data.length > 0 && (
                <div>
                  <h1>Members</h1>
                  <span className={styles.membersCount}>
                    {`${selectedMembers.length + members.length} / 
                      ${(group &&
                        group.active_subscription &&
                        group.active_subscription.plan)
                        ?
                        group.active_subscription.plan.max_group_chat_size
                        :
                        0
                      }`}
                  </span>
                </div>
              )}
            </>
          }
          TableSection={
            <>
              {nonGroupMembers.data.length > 0 && (
                <>
                  {nonGroupMembers.data.map((member: any) => {
                    const _isMemberSelected = selectedMembers.some((selectedMember: any) => selectedMember.user.id === member.user.id);
                    return (
                      <CommMember
                        group={group}
                        member={member}
                        userSelected={_isMemberSelected}
                        toggleUserSelected={toggleUserSelected}
                      />
                    )
                  })
                  }
                </>
              )}
            </>
          }
          EmptyAndLoadingComp={
            <>
              {loadingCommunityMembers &&
                <div style={{ height: '100%', width: '100%' }}>
                  {
                    Array(12).fill('').map((_e, i) => (
                      <AddUsersToContentPopUpLoader key={i} />
                    ))
                  }
                </div>
              }
              {(!loadingCommunityMembers && nonGroupMembers.data.length === 0) &&
                <div className={styles.emptyContainer}>
                  <h2>No results found</h2>
                  <p>Search for community members to add them to this group message.</p>
                </div>
              }
            </>
          }
          PaginationComp={
            <>
              {nonGroupMembers.data.length > 0 && (
                <div className={styles.paginationDropdown}>
                  <PaginationDropdown
                    currentPage={nonGroupMembers.current_page}
                    lastPage={nonGroupMembers.last_page}
                    onPageChanged={(page: any) => loadMoreNonGroupMembers(page)}
                  />
                </div>
              )}
            </>
          }
        />
      </>
    </div>
  );
};

function GroupChatProfilesSidebar(props: any) {

  const validMembers = props.members

  const InactiveMember = (_member: any) => {
    return (
      _member.community_member &&
      !_member.community_member.active_subscription &&
      !props.isChatAdmin(props.chatroom, _member.community_member.id) 
    )
  }

  return (
    validMembers && (
      <PerfectScrollbar className="messages-chat-members">
        <div className="messages-chat-members-header">
          <b>Members
            <span style={{ marginLeft: '4px' }}>({validMembers ? (validMembers.length) : 0})</span>
            <span
              className="close"
              onClick={() => props.toggleProfilesView()}
            >
              <CloseIcon />
            </span>
          </b>
        </div>
        <div className="messages-chat-members-body">
          <ul>
            {validMembers
              .sort((a: any, b: any) => props.isChatAdmin(props.chatroom, a.community_member.id) ? -1 : 1)
              .map((member: any, index: any) => (
                member.community_member.user && (
                  <li
                    key={member.id}
                    className="member-container"
                  >
                    <div
                      onClick={() => props.viewProfile(member)}
                      className={`member-details ${props.isChatAdmin(props.chatroom, member.community_member.id || InactiveMember(member)) ? "admin" : ""}`}>
                      <UserComponent
                        hideAdmin={true}
                        user={member.community_member.user}
                        profilePicture={member.community_member.user.profile_image}
                        showProfileSlider={false}
                      />
                    </div>
                    {props.isChatAdmin(props.chatroom, member.community_member.id) && (
                      <img src={require("../images/admin.svg")} />
                    )}
                    {InactiveMember(member) && member.community_member.role.name === 'member' && (
                      <span className="icon">
                        <DeletedUserIcon />
                      </span>
                    )}
                    {props.isChatAdmin(props.chatroom, props.group.user_membership.id) ?
                      <div>
                        <ActionsDropdown
                          objectId={member}
                          actions={
                            props.group.user_membership.id === member.community_member.id ?
                              [
                                {
                                  "name": "View profile",
                                  "callback": props.viewProfile
                                }
                              ] :
                              [
                                {
                                  "name": "Remove",
                                  "callback": props.openModal
                                },
                                {
                                  "name": "View profile",
                                  "callback": props.viewProfile
                                }
                              ]
                          }
                        />
                      </div>
                      :
                      <div>
                        <ActionsDropdown
                          objectId={member}
                          actions={
                            props.group.user_membership.id === member.community_member.id ?
                              [
                                {
                                  "name": "View Profile",
                                  "callback": props.viewProfile
                                },
                                {
                                  "name": "Leave",
                                  "callback": props.openLeaveGroupchatModal
                                }
                              ] :
                              [
                                {
                                  "name": "View Profile",
                                  "callback": props.viewProfile
                                }
                              ]
                          }
                        />
                      </div>

                    }
                  </li>
                )
              ))}
            <li>
              {props.isChatAdmin(props.chatroom, props.group.user_membership.id) ?
                <>
                  {
                    (validMembers.length < Number(props.group.active_subscription.plan.max_group_chat_size)) &&
                <button
                  onClick={() => {
                    props.openAddMemberModal();
                    props.setSearchQuery("");
                  }}
                  className="user-icon-container"
                >
                  <span className="user-icon">
                    <AddUserIcon />
                  </span>
                  Add member
                </button>
                  }
                </>
                :
                <button
                  className="leave-group user-icon-container"
                  onClick={() => props.openLeaveGroupchatModal()}>
                  <img src={require("../images/trash.svg")} alt="..." />Leave group
                </button>
              }
            </li>
          </ul>
        </div>
      </PerfectScrollbar>
    )
  );
}

const GroupProfileImages = ({ members, group, chat }: { members: any, group: any, chat: any }) => {

  const { membersRef } = React.useContext(DirectChatsContext)

  const sortedMembers = chat.members.length > 0 && chat.members.sort((a: any, b: any) => a.id - b.id);
  const membersCount = membersRef.current !== null && chat.id === membersRef.current.chatroomID && membersRef.current.members_count

  return (
    <ul className="group-profile-pic">
      {sortedMembers.slice(0, 3).map((member: any, index: any) => (
        <li key={index}>
          <UserComponent
            key={chat.id}
            hideAdmin={true}
            user={member.community_member.user}
            hideName={true}
            profilePicture={member.community_member.user && member.community_member.user.profile_image}
            showProfileSlider={false}
          />
        </li>
      ))}
      {chat.members_count > 3 && (
        <li className="message-plus-members">
          <UserComponent
            key={chat.id}
            hideAdmin={true}
            user={chat.members[chat.members.length - 1].community_member.user}
            hideName={true}
            profilePicture={chat && chat.members && chat.members.length > 0 && chat.members[chat.members.length - 1].community_member && chat.members[chat.members.length - 1].community_member.user && chat.members[chat.members.length - 1].community_member.user.profile_image}
            showProfileSlider={false}
          />
          <span className="member-count">+{membersCount ? membersCount - 3 : chat.members_count - 3}</span>
        </li>
      )}
    </ul>
  )
}

function SingleChatMemberProfile(props: any) {

  return props.member ? (
    <div className="members-new-profile">

      <div className="header">
        {props.isGroupChat
          ?
          <span
            className="back"
            onClick={() => props.setIsViewProfile(false)}
            style={miscUtils.customThemeSet(props.theme) ? { color: props.theme.custom.primaryColor } : {}}
          >
            <FontAwesomeIcon icon={faChevronLeft} /> Back to members
          </span>
          :
          <span
            className="back"
            onClick={() => props.toggleProfilesView()}
            style={miscUtils.customThemeSet(props.theme) ? { color: props.theme.custom.primaryColor } : {}}
          >
            <FontAwesomeIcon icon={faChevronLeft} /> Close profile
          </span>
        }
      </div>

      <HeaderMemberDetails
        userMembership={{ membership: props.member.community_member && props.member.community_member }}
      />

      {
        (miscUtils.isAdmin((props.group && props.group.user_membership))
          || miscUtils.isModerator((props.group && props.group.user_membership))) &&
        <SubscriptionMemberDetails
          userMembership={props.member.community_member && props.member.community_member}
        />
      }
      <BioMemberDetails
        user={props.member.community_member && props.member.community_member}
        group={props.group && props.group}
      />

      {
        props.member.community_member &&
        props.member.community_member.screening_response &&
        <CustomFieldsMemberDetails
          screeningResponse={props.member.community_member.screening_response}
          group={props.group && props.group}
        />
      }
    </div>
  ) :
    (
      <></>
    )
}

const CommMember = (
  {
    group,
    member,
    userSelected,
    toggleUserSelected,
  }: {
    group: any
    member: any
    userSelected: any
    toggleUserSelected: any
  }
) => {
  return (
    <div className={styles.tableRow}>
      <input
        type="checkbox"
        checked={userSelected}
        onClick={() => toggleUserSelected(member)}
      />

      <div className={styles.tableRow__Body}>
        <CustomUserComponent user={member} group={group} />
      </div>

    </div>
  )
}

export default withRouter(
  connect(null, null)(Chatroom as any) as any
) as any;
